<template>
  <div class="doc_wrapper">
    <quic-filter @selected="selected" :list="list"/>
  </div>
</template>

<script>
import QuicFilter from '@/components/QuickFilter'

export default {
  name: 'adx-saved-quick-filter-doc',
  components: {
    QuicFilter
  },
  data() {
    return {
      list: [
        {
          'id': 0,
          'name': 'All',
          'label': 'All',
          'value': '',
        },
        {
          'id': 1,
          'name': 'Retaurants',
          'label': 'Restaurants',
          'value': 'RE'
        },
        {
          'id': 2,
          'name': 'Cafe',
          'label': 'Cafe',
          'value': 'CA'
        },
        {
          'id': 3,
          'name': 'Salon and Beauty',
          'label': 'Salon and Beauty',
          'value': 'SNB'
        },
        {
          'id': 4,
          'name': 'Fitness Club',
          'label': 'Fitness Club',
          'value': 'FC'
        },
      ],
    }
  },
  methods: {
    selected(item){
      
    },
  }

}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>